var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import './style.css';
import { SylUnionPlugin } from '@syllepsis/adapter';
import merge from 'lodash.merge';
import { columnResizing, isInTable, tableEditing } from 'prosemirror-tables';
import { tableCellSelfResizing } from './cell-self-resizing';
import { BUTTON_DEFAULT_CONFIG } from './component/menu-button';
import { TABLE_CONFIG } from './const';
import { createTableCellPlugin } from './table-cell';
import { createTableHeaderPlugin } from './table-header';
import { TableHelperPlugin } from './table-helper';
import { TableItemPlugin } from './table-item';
import { createTableRowPlugin } from './table-row';
var DEFAULT_PROPS = {
    columnResize: { handleWidth: 5, cellMinWidth: 56 },
    table: TABLE_CONFIG,
    button: BUTTON_DEFAULT_CONFIG,
};
// locale menuTip
var TablePlugin = /** @class */ (function (_super) {
    __extends(TablePlugin, _super);
    function TablePlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'table';
        return _this;
    }
    TablePlugin.prototype.init = function (editor, props) {
        var config = merge({}, DEFAULT_PROPS, props);
        var sylPlugins = [
            { plugin: createTableCellPlugin(config.table) },
            { plugin: createTableRowPlugin(config.table) },
            { plugin: TableItemPlugin, controllerProps: __assign(__assign({}, config.table), config.button) },
        ];
        if (config.table.useTableHeader)
            sylPlugins.push({ plugin: createTableHeaderPlugin(config.table) });
        return {
            nativePlugins: [columnResizing(config.columnResize), tableEditing(config.table), TableHelperPlugin(editor), tableCellSelfResizing()],
            sylPlugins: sylPlugins,
        };
    };
    return TablePlugin;
}(SylUnionPlugin));
export { isInTable, TablePlugin };
//# sourceMappingURL=index.js.map